import { render, staticRenderFns } from "./BillingDetailSummaryHandlingChargeIndex.vue?vue&type=template&id=20fc58d8&scoped=true&"
import script from "./BillingDetailSummaryHandlingChargeIndex.vue?vue&type=script&lang=js&"
export * from "./BillingDetailSummaryHandlingChargeIndex.vue?vue&type=script&lang=js&"
import style0 from "./BillingDetailSummaryHandlingChargeIndex.vue?vue&type=style&index=0&id=20fc58d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fc58d8",
  null
  
)

export default component.exports